import PropTypes from "prop-types"
import { get, isObject } from "lodash"
import classNames from "classnames"
import Tooltip from "components/material/tooltip"
import { InfoOutlined } from "@mui/icons-material"

import "./styles.scss"

export default function ValueWithTooltip({ value, ...props }) {
  if (!isObject(value)) { return value }

  const { value: displayedValue, tooltip } = value
  return <Tooltip title={tooltip} className={classNames("value-with-tooltip", get(props, "className", ""))}>
    <span className="value-wrapper">
      <InfoOutlined />
      <span>{displayedValue}</span>
    </span>
  </Tooltip>
}

const VALUE_WITH_TOOLTIP = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
})

ValueWithTooltip.propTypes = {
  value: PropTypes.oneOfType([VALUE_WITH_TOOLTIP, PropTypes.string, PropTypes.number]),
}
